export const baseUrlEndPoint = (url) => {
  const checkLocation = location?.hostname;
  if (checkLocation === "fe-dev-patient-simulator.reyna-solutions.com") {
    return `https://be-dev-patient-simulator.reyna-solutions.com/api/${url}`;
  } else if (checkLocation === "fe-qa-patient-simulator.reyna-solutions.com") {
    return `https://be-qa-patient-simulator.reyna-solutions.com/api/${url}`;
  } else if (checkLocation === "10.0.243.73") {
    return `http://10.0.243.73:5001/api/${url}`;
  } else if (checkLocation === "fe-uat-patient-simulator.reyna-solutions.com") {
    return `https://be-uat-patient-simulator.reyna-solutions.com/api/${url}`;
  } else if (checkLocation === "fe-medical-simulator.reyna-solutions.in") {
    return `https://be-medical-simulator.reyna-solutions.in/api/${url}`;
  } else {
    // return `https://be-dev-patient-simulator.archesoftronix.in/api/${url}`;
    return `http://localhost:5001/api/${url}`;
    // return `https://be-qa-patient-simulator.archesoftronix.in/api/${url}`;
    // return `https://capacity-specs-effort-checked.trycloudflare.com/api/${url}`;
  }
};

// export const getFileUrl = "https://6eacaeb669c3.ngrok-free.app/api/files/get";

export const APP_VERSION = process.env.REACT_APP_VERSION;

export const api = {
  establishment: baseUrlEndPoint("super-admin/establishment"),
  pathology: baseUrlEndPoint("super-admin/pathology"),
  getSpeciality: baseUrlEndPoint("super-admin/pathology/get-specialty"),
  userManagement: baseUrlEndPoint("super-admin/user-mng"),
  getDomains: baseUrlEndPoint("super-admin/user-mng/domain"),
  getAllEstablishment: baseUrlEndPoint("super-admin/establishment/all"),
  getLevels: baseUrlEndPoint("super-admin/user-mng/level"),
  importUtils: baseUrlEndPoint("utils/import"),
  superAdminMasterGet: baseUrlEndPoint("super-admin/master/type/get"),
  superAdminMaster: baseUrlEndPoint("super-admin/master"),
  login: baseUrlEndPoint("auth/sign-in"),
  forgotPassword: baseUrlEndPoint("auth/password/forgot"),
  changePassword: baseUrlEndPoint("auth/password/reset"),
  manageLanguage: baseUrlEndPoint("super-admin/user-mng/language"),
  materials: baseUrlEndPoint("super-admin/materials"),
  materialsImport: baseUrlEndPoint("super-admin/materials/import"),
  getAllCategories: baseUrlEndPoint("super-admin/category-master/get-all"),
  getAllTreatments: baseUrlEndPoint("super-admin/treatment-master"),
  treatment: baseUrlEndPoint("super-admin/treatment-master"),
  importTreatment: baseUrlEndPoint("super-admin/treatment-master/import"),
  complimentaryExaminations: baseUrlEndPoint("super-admin/comp-examination"),
  getAzureAdRedirectUrl: baseUrlEndPoint("auth/login"),
  generalOverview: baseUrlEndPoint("auth/dashboard"),
  getAllCases: baseUrlEndPoint("super-admin/cases"),
  createTargetGroups: baseUrlEndPoint("super-admin/target-group"),
  getTargetGroups: baseUrlEndPoint("super-admin/target-group"),
  getUsers: baseUrlEndPoint("super-admin/target-group/users"),
  consultationRoom: baseUrlEndPoint("super-admin/consultation/room"),
  emergencyRoom: baseUrlEndPoint("super-admin/emergency/room"),
  examinationRoom: baseUrlEndPoint("super-admin/examination/room"),
  cases: baseUrlEndPoint("super-admin/cases"),
  modes: baseUrlEndPoint("super-admin/modes"),
  getCaseFormData: baseUrlEndPoint("super-admin/cases/step"),
  getUsersByIds: baseUrlEndPoint("super-admin/user-mng/byIds"),
  casesPathology: baseUrlEndPoint("super-admin/cases/pathology"),
  casesComplimentoryExamination: baseUrlEndPoint(
    "super-admin/cases/complimentory-examination"
  ),
  caseTreatmentCategory: baseUrlEndPoint(
    "super-admin/cases/treatment-category"
  ),
  casesClone: baseUrlEndPoint("super-admin/cases/clone"),
  stepStatus: baseUrlEndPoint("super-admin/cases/step-status"),
  teacherCaseMgmt: baseUrlEndPoint("teacher/case-mng/list"),
  getTeacher: baseUrlEndPoint("super-admin/user-mng/get/Teachers"),
  teacherCaseUpdate: baseUrlEndPoint("teacher/case-mng/status"),
  studentCaseList: baseUrlEndPoint("student/case-mng/list"),
  studentImport: baseUrlEndPoint("super-admin/target-group/student-import"),
  getTeacherUsers: baseUrlEndPoint("teacher/case-mng/student-list"),
  virtualPatient: baseUrlEndPoint("virtual-patient"),
  casesList: baseUrlEndPoint("super-admin/cases/list"),
  pointEvaluation: baseUrlEndPoint("super-admin/cases/point-evaluation"),
  caseEvaluationStep: baseUrlEndPoint("case_evaluation/step"),
  getDebrefingData: baseUrlEndPoint("case_evaluation/transaction"),
  virtualPatientCasePathology: baseUrlEndPoint(
    "virtual-patient/case-pathology"
  ),
  teacherMonotoringList: baseUrlEndPoint("teacher/monitoring/list"),
  finishCase: baseUrlEndPoint("case_evaluation/finish"),
  teacherDebriefing: baseUrlEndPoint("teacher/monitoring/debriefing"),
  teacherMonotoringFilter: baseUrlEndPoint("teacher/monitoring/filter"),
  caseEvaluationCheckSteps: baseUrlEndPoint("case_evaluation/check-step"),
  getPatientList: baseUrlEndPoint("virtual-patient/list"),
  addPatient: baseUrlEndPoint("virtual-patient"),
  viewPatient: baseUrlEndPoint("virtual-patient/views"),
  viewPatientGetPositionTypes: baseUrlEndPoint(
    "virtual-patient/views/get-types"
  ),
  getDashboardData: baseUrlEndPoint("super-admin/dashboard/report"),
  getInitialCase: baseUrlEndPoint("case_evaluation/initial-case"),
  uploadFileUrl: baseUrlEndPoint("files/upload"),
  // uploadFileUrl:
  //   "https://pdt-pledge-union-directed.trycloudflare.com/api/files/upload",
  getFileUrl: baseUrlEndPoint("files/get"),
  // getFileUrl:
  //   "https://be-dev-patient-simulator.reyna-solutions.com/api/files/get",
};
